import { ApiMananger } from "./apiMananger";

const classeApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getClasses: build.query({
      query: () => `/classes/main/`,
      providesTags: ["Classes"],
      keepUnusedDataFor: 60 * 60, // Garder en cache pendant 1 heure
    }),
    getClassesAll: build.query({
      query: () => `/classes/`,
      providesTags: ["Classes"],
      keepUnusedDataFor: 60 * 60, // Garder en cache pendant 1 heure
    }),
  }),
});

export const { useGetClassesQuery, useGetClassesAllQuery } = classeApi;
